export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_TOKEN = 'SET_TOKEN';

export function setLoading(loading) {
  return {
    type: SET_LOADING,
    value: loading
  };
}

export function setError(error) {
  return {
    type: SET_ERROR,
    value: error
  };
}

export function setToken(token) {
  return {
    type: SET_TOKEN,
    value: token
  };
}



// WEBPACK FOOTER //
// ./src/actions/global.js